// Modules
import React, { ReactElement, useState } from 'react';

// Styled Components
import * as EVENT from './event-contact.styles';

// Types
import { Event } from '../../types/events';

import ContactIcon from '../../assets/contact.svg';

// Constants
import { constant } from '../../constants/contant';

const EventContact = ({
	lang,
	dir,
	event,
}: {
	event: Event;
	lang: string;
	dir: string;
}): ReactElement => {
	// Render
	return (
		<EVENT.Contact>
			<EVENT.ContactIcon src={ContactIcon} direction={dir} alt="Contact"/>
			<div>
				<EVENT.PBold>{constant[lang].VARIABLES.CONTACT}</EVENT.PBold>
				{event.contact.phoneLabel && event.contact.phone && (
					<EVENT.P>
						{event.contact.phoneLabel}: {event.contact.phone}
					</EVENT.P>
				)}
				{event.contact.email && (
					<EVENT.P>{constant[lang].VARIABLES.EMAIL} : {event.contact.email} </EVENT.P>
				)}
				{event.contact.title && event.contact.url && (
					<EVENT.P>
						{event.contact.title} :  {event.contact.url}
					</EVENT.P>
				)}
			</div>
		</EVENT.Contact>
	);
};

export default EventContact;
